<template>

  <small class="password-strength-hint form-text" :class="{ show: show }">
    <div v-if="progressbar" class="strength-progress-wrap">
      <div class="strength-progress">
        <div v-for="index in maxScore" :key="index" class="strength-progress--bar" :class="{ 'bar-active': index <= passwordScore }"></div>
      </div>
    </div>
    <transition name="fade" appear mode="out-in">
      <span v-if="passwordScore === 0" :key="passwordScore" class="text-danger">
        {{ $gettext('Please choose a secure password: at least six characters, mix case, letters and other characters.') }}
      </span>
      <span v-if="passwordScore === 1" :key="passwordScore">
        <font-awesome-icon icon="fa-regular fa-warning" class="text-warning"/>{{ $gettext('Your password is ok, although it could be safer. Try making it a bit longer.') }}
      </span>
      <span v-if="passwordScore === 2" :key="passwordScore">
        <font-awesome-icon icon="fa-regular fa-circle-check" class="text-primary"/>{{ $gettext('Good work. Your password is safe.') }}
      </span>
      <span v-if="passwordScore === 3" :key="passwordScore">
        <font-awesome-icon icon="fa-regular fa-circle-check" class="text-primary"/>{{ $gettext('Good work. This password is excellent.') }}
      </span>
      <span v-if="passwordScore === 4" :key="passwordScore">
        <font-awesome-icon icon="fa-regular fa-circle-check" class="text-primary"/>{{ $gettext('Awesome! Can you even remember this?') }}
      </span>
    </transition>
  </small>

</template>

<script>
export default {
  name: 'PasswordStrengthHint',
  props: {
    password: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    progressbar: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      passwordScore: 0,
      maxScore: 4
    }
  },
  watch: {
    password () {
      if (this.zxcvbnLoaded) {
        this.getPasswordStrength()
      }
    }
  },
  created () {
    this.loadPasswordStrengthScript()
  },
  methods: {
    loadPasswordStrengthScript () {
      if (typeof window.zxcvbn !== 'function') {
        const script = document.createElement('script')
        script.src = '/static/lib/zxcvbn.js'
        script.onload = () => {
          this.zxcvbnLoaded = true
          this.getPasswordStrength()
        }
        script.onerror = () => {
          console.error('PasswordStrengthHint::loadPasswordStrengthScript() -> Failed to load zxcvbn script.')
        }
        document.body.appendChild(script)
      }
    },
    getPasswordStrength () {
      const zxcvbnScore = window.zxcvbn(this.password)
      this.passwordScore = zxcvbnScore.score
      this.$emit('score-changed', this.passwordScore)
    }
  }
}
</script>

<style lang="scss" scoped>
  .password-strength-hint {
    opacity: 0;
    &.show {
      opacity: 1;
    }
    span {
      .svg-inline--fa {
        margin-right: 0.25rem
      }
    }

    .strength-progress-wrap {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      padding-top: 0.5rem;
      padding-bottom: 0.75rem;
      .strength-progress {
        display: flex;
        gap: 0.5rem;
        &--bar {
        border-radius: 10px;
        background: $colorUnassigned;
        height: 4px;
        width: 100%;
          &.bar-active {
            background: $colorBrand;
          }
        }
      }
    }
  }

</style>